import { z } from 'zod';
export const PeriodStatusSchema = z.enum(['CLOSED', 'OPEN', 'FUTURE']);
// NOTE: This is the Period MASTER row (one per company per accounting month).
// `common.ts` already exports a different `PeriodSchema`/`Period` that models a
// {year, month} value object used elsewhere in the codebase. To avoid the
// barrel-level name collision we expose this master under `PeriodMasterSchema`
// / `PeriodMaster`. Prisma model name remains `Period`; the Prisma client type
// is referenced as `Prisma.Period`, not via this Zod export.
export const PeriodMasterSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    // YYYYMM, e.g. '202604'
    period: z.string().regex(/^\d{6}$/),
    nameTh: z.string().min(1),
    status: PeriodStatusSchema,
    closedBy: z.string().nullable().optional(),
    // ISO datetime string on the wire; service converts to Date for Prisma.
    closedDate: z.iso.datetime().nullable().optional(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreatePeriodMasterSchema = PeriodMasterSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdatePeriodMasterSchema = CreatePeriodMasterSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=period.js.map